import { render, staticRenderFns } from "./RefreshTriggerCacheButton.vue?vue&type=template&id=9aff4d6c&"
import script from "./RefreshTriggerCacheButton.vue?vue&type=script&lang=js&"
export * from "./RefreshTriggerCacheButton.vue?vue&type=script&lang=js&"
import style0 from "./RefreshTriggerCacheButton.vue?vue&type=style&index=0&id=9aff4d6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports